import axios from "@/lib/axios";
import { Resource } from "@/types/resources";

export type ListEditionResourcesByTagRequestParams = {
  editionId: string;
  resourceLibraryId: string;
  tag: string;
};

export type ListEditionResourcesByTagResponse = Resource[];

export const listEditionResourcesByTag = (
  params: ListEditionResourcesByTagRequestParams,
) =>
  axios
    .get<ListEditionResourcesByTagResponse>(
      `/v1/editions/${params.editionId}/resource-libraries/${params.resourceLibraryId}/resources/tag`,
      {
        params: {
          tag: params.tag,
        },
      },
    )
    .then((res) => res.data);
